import { useFrame } from '@react-three/fiber';
import { useEffect } from 'react';

import {
  type PlayerCameraControlsHandle,
  usePlayerCameraControls,
  usePlayerStoreApi,
} from '@cartwhl/3d/player';

import { useStore as useKeyPoseStore } from '../keyPoseStore';

type CameraControlsWithEnabled = PlayerCameraControlsHandle & {
  enabled?: boolean;
};

export function useKeyPoseEditingCameraGate() {
  const keyPoseStore = useKeyPoseStore();
  const playerStore = usePlayerStoreApi();
  const { cameraControls } = usePlayerCameraControls();
  const dragging = keyPoseStore.state.editing.dragging;

  useEffect(() => {
    const controls = cameraControls as CameraControlsWithEnabled | null;

    if (dragging) {
      playerStore.setGizmoDragging(true);
      if (!controls || typeof controls.enabled !== 'boolean') {
        return;
      }
      controls.cancel?.();
      controls.stop?.();
      controls.enabled = false;
      return;
    }

    playerStore.setGizmoDragging(false);
    if (!controls || typeof controls.enabled !== 'boolean') {
      return;
    }

    controls.stop?.();
    playerStore.restoreGizmoCameraSnapshot(controls);
    playerStore.suppressCharacterAutoFitAfterGizmo();
    controls.enabled = true;
  }, [cameraControls, dragging, playerStore]);

  useFrame(() => {
    if (!playerStore.state.camera.gizmoDragging) {
      return;
    }

    const controls = cameraControls as CameraControlsWithEnabled | null;
    if (!controls) {
      return;
    }

    if (controls.enabled) {
      controls.enabled = false;
    }
    controls.cancel?.();
  });
}
